import VitrineNav from './VitrineNav';
/* ⚠️ `LandingPage.css` EST IMPORTÉ ICI EXPLICITEMENT, et ce n'est pas redondant.
      `QuiSommesNous.css` ne définit AUCUNE classe de chrome — zéro `.vt-nav`,
      zéro `.vt-footer` (mesuré). Cette page ne s'affichait correctement que
      parce que CRA fusionne tout le CSS du bundle en un seul `main.*.css` :
      elle dépendait donc de l'import fait par une AUTRE page. Ça marche, mais
      ce n'est pas déclaré — et le jour où la vitrine passe en chargement
      différé par route, la page perd son en-tête sans que rien n'ait changé
      chez elle. Aucune règle CSS n'est ajoutée : seul l'import est rendu
      explicite. */
import './LandingPage.css';
import './QuiSommesNous.css';

export default function QuiSommesNous() {
  /* 🔴 CETTE PAGE POSAIT SES PROPRES MÉTAS — RETIRÉ LE 14/10/2026.
   * ⚠️ C'ÉTAIT UNE SECONDE SOURCE, et elle gagnait : le pré-rendu écrivait la
   *    bonne description dans le HTML statique, puis cet effet l'ÉCRASAIT à
   *    l'hydratation. La recette du lot l'a trouvée en mesurant 168 caractères
   *    là où la table en déclare 141.
   * ⓘ Sa description est reprise dans `src/seo/pages.js`, raccourcie sous les
   *   160 caractères — l'ancienne était tronquée par Google sans que personne
   *   le voie. Le nom du fondateur reste dans le CORPS de la page, où il est
   *   écrit en toutes lettres.
   * ➡️ Les métas de cette page viennent désormais de `<Seo />`, monté une fois
   *    au-dessus du routeur. */
  return (
    <div className="vt qsn">
      <VitrineNav />

      {/* Hero */}
      <section className="qsn-hero">
        <h1 className="qsn-hero-title">Qui sommes-nous</h1>
        <p className="qsn-hero-sub">
          La sécurité privée en Afrique francophone mérite des outils à la hauteur de ses ambitions.
        </p>
      </section>

      {/* Mot du fondateur */}
      <section className="qsn-fondateur">
        <div className="qsn-fondateur-inner">
          <div className="qsn-fondateur-left">
            <img
              src="/images/fondateur-gss360.png"
              alt="Dominique A. SOMABEY"
              className="qsn-fondateur-photo"
            />
            <h2 className="qsn-fondateur-name">Dominique A. SOMABEY</h2>
            <div className="qsn-fondateur-titre">
              Directeur Général — Gladiator Security Systems &amp; Fox Sécurité Services-Togo
            </div>
            <div className="qsn-fondateur-sous-titre">
              Éditeur de GSS-360 · Agréé N° 0265 MSPC-CAB
            </div>
          </div>
          <div className="qsn-fondateur-text">
            <p className="qsn-fondateur-mot">
              Directeur Général de Fox Sécurité Services-Togo, agréée sous le N° 0265 MSPC-CAB
              du 12 février 2021, j'ai vécu de l'intérieur les défis quotidiens des dirigeants
              de sociétés de sécurité privée en Afrique francophone.
            </p>
            <p className="qsn-fondateur-mot">
              Cette expérience terrain m'a convaincu : notre secteur mérite une solution de gestion
              intégrale, conforme à nos réalités juridiques et adaptée à nos contraintes
              opérationnelles — pas des logiciels pensés ailleurs et adaptés après coup.
            </p>
            <p className="qsn-fondateur-mot">
              C'est pour répondre à ce besoin réel que j'ai fondé Gladiator Security Systems,
              {/* 🔴 UNE AFFIRMATION DE RANG A ÉTÉ RETIRÉE ICI LE 16/10/2026 — décision
                   de Dom. Elle plaçait le produit en tête d'un classement que rien
                   n'établit. Le 14/10, la même affirmation avait quitté les
                   méta-données servies aux moteurs ; elle survivait dans le CORPS de
                   cette page, c'est-à-dire à l'endroit le plus lu.
                   ⓘ La phrase ne perd rien d'autre : « un ERP natif IA conçu
                     spécifiquement pour… » dit ce que le produit EST et pour QUI il
                     est fait. Un concurrent peut contester un classement, pas une
                     description. */}
              intégrateur de systèmes de sécurité, et développé GSS-360 : un ERP natif IA
              conçu spécifiquement pour les sociétés de sécurité privée en zone OHADA.
            </p>
            <p className="qsn-fondateur-mot">
              GSS-360 est construit pour grandir avec vous — à votre rythme, selon vos réalités.
              La rigueur du terrain, la puissance du numérique.
            </p>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="qsn-mission">
        <p className="qsn-mission-text">
          <span style={{ color: '#C83232', fontWeight: 700 }}>«&nbsp;</span>
          Gladiator Security Systems développe GSS-360 pour que chaque dirigeant de société
          de sécurité en zone OHADA dispose enfin d'un outil à la hauteur de son métier,
          adapté à ses réalités.
          <span style={{ color: '#C83232', fontWeight: 700 }}>&nbsp;»</span>
        </p>
      </section>

      {/* Footer */}
      <footer className="vt-footer">
        <div className="vt-footer-inner">
          <div>
            <div className="vt-footer-name-row">
              {/* ⚠️ Pastille claire : le PNG est OPAQUE quasi blanc (RGBA 253,253,253,255
                  mesuré), le pied de page est en #16161C. Sans fond clair, un rectangle
                  lumineux. La ligne « Gladiator Security Systems » est retirée : le logo
                  porte déjà son wordmark, elle l'affichait deux fois à 12 px d'intervalle.
                  Elle survit dans l'alt, seul endroit où elle manquerait à un lecteur d'écran. */}
              <span className="vt-footer-pastille">
                <img
                  src="/logo-gladiator.png"
                  alt="Gladiator Security Systems, éditeur de GSS-360"
                  className="vt-footer-logo"
                  width="292"
                  height="234"
                  loading="lazy"
                />
              </span>
              <div>
                <div className="vt-footer-tagline">Éditeur de GSS-360, intégrateur de systèmes de sécurité</div>
              </div>
            </div>
            <div className="vt-footer-legal">
              RCCM TG-LFW-01-2024-B13-00449 · NIF 1001930788<br />
              Tokoin-Wuiti, Rue Air-Burkina, Lomé
            </div>
          </div>
          <div>
            <div className="vt-footer-col-title">Contact</div>
            <div className="vt-footer-contact">
              +228 92 53 15 14<br />+228 22 61 09 61
            </div>
            <a href="https://wa.me/22890054083" target="_blank" rel="noopener noreferrer" className="vt-footer-wa">
              <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp : +228 90 05 40 83
            </a>
          </div>
          <div>
            <div className="vt-footer-col-title">Liens</div>
            <div className="vt-footer-links">
              <a href="/mentions-legales" className="vt-footer-link">Mentions légales</a>
              <a href="/confidentialite" className="vt-footer-link">Confidentialité</a>
              <a href="/faq" className="vt-footer-link">FAQ</a>
              <a href="/login" className="vt-footer-link">Se connecter</a>
            </div>
          </div>
        </div>
        <div className="vt-footer-copy">
          © 2026 Gladiator Security Systems. Tous droits réservés.
        </div>
      </footer>

      {/* WhatsApp flottant */}
      <a
        href="https://wa.me/22890054083?text=Bonjour%2C%20je%20souhaite%20en%20savoir%20plus%20sur%20GSS-360."
        target="_blank"
        rel="noopener noreferrer"
        className="vt-whatsapp"
        title="Nous écrire sur WhatsApp"
      >
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>
    </div>
  );
}
